import { render, staticRenderFns } from "./SASExploreSlug.vue?vue&type=template&id=48600c1c&scoped=true&"
import script from "./SASExploreSlug.vue?vue&type=script&lang=js&"
export * from "./SASExploreSlug.vue?vue&type=script&lang=js&"
import style0 from "./SASExploreSlug.vue?vue&type=style&index=0&id=48600c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48600c1c",
  null
  
)

export default component.exports